import { render } from "./MainDataOrganization.vue?vue&type=template&id=416dd496"
import script from "./MainDataOrganization.vue?vue&type=script&lang=js"
export * from "./MainDataOrganization.vue?vue&type=script&lang=js"

import "./MainDataOrganization.vue?vue&type=style&index=0&id=416dd496&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__